// Mock data for B2B Wall Art Manufacturer Website

export const translations = {
  en: {
    nav: {
      capabilities: "Our Services",
      technology: "Technology",
      pricing: "Pricing",
      contact: "Partnership"
    },
    hero: {
      title: "Scale Your Wall Art Business Without Production Stress",
      subtitle: "We produce premium canvas wall art in 5 business days and ship across the USA and Canada with optimized rates—so you can focus on design and sales.",
      primaryCTA: "Request Partnership",
      secondaryCTA: "See Our Capabilities"
    },
    whyUs: {
      title: "Why Partners Choose Us",
      features: [
        {
          title: "Canon Colorado Printing",
          description: "Sharp detail, consistent color, production reliability"
        },
        {
          title: "Automated Stretching",
          description: "German automatic machines for consistent, hands-off finishing"
        },
        {
          title: "Custom Packaging",
          description: "Exact-size boxes made in-house for better protection"
        },
        {
          title: "Fast Fulfillment",
          description: "Production in 5 business days, streamlined shipping to USA & Canada"
        }
      ]
    },
    printing: {
      title: "Canon Colorado UVGel Technology",
      description: "Advanced UVGel 860 ink technology delivers exceptional scratch-resistant prints with vivid, bold colors. Our low-temperature curing process ensures dimensional stability while the instant-dry output maintains perfect canvas texture. Experience high mechanical robustness, chemical resistance, and outstanding color gamut across all your prints."
    },
    packaging: {
      title: "Custom Boxes Made to Fit Each Order",
      description: "Our box-making system produces the exact size needed, helping reduce damage, saving space, and improving delivery reliability."
    },
    frames: {
      title: "Gallery Wrapped & Floating Frame Options",
      description: "Offer premium gallery wrapped canvas and floating frame options in Walnut, Natural, Black, and White finishes. Each frame includes mounting hardware and comes ready to hang. Available in standard and Extra Large sizes to meet every customer need."
    },
    shipping: {
      title: "Insured FedEx Shipping to USA & Canada",
      description: "Production complete within 5 business days, then shipped via FedEx with full insurance. Any damage in transit? We take full responsibility and ship a free replacement immediately—no questions asked."
    },
    pricing: {
      title: "Best Product & Shipping Rates",
      subtitle: "Competitive pricing with flexible daily and weekly payment options",
      size: "Size",
      price: "Price",
      currency: "USD",
      paymentOptions: "Daily & Weekly Payment Options Available"
    },
    finalCTA: {
      title: "Ready to Stop Managing Production?",
      description: "Share your sales channels and daily volume. We'll respond with next steps.",
      cta: "Request Partnership"
    },
    form: {
      title: "Partnership Request",
      name: "Full Name",
      company: "Company Name",
      email: "Email Address",
      phone: "Phone Number",
      website: "Company Website",
      salesChannels: "Sales Channels",
      salesChannelsPlaceholder: "e.g., Etsy, Shopify, Amazon",
      orderVolume: "Daily/Monthly Order Volume",
      orderVolumePlaceholder: "e.g., 50 orders/day",
      message: "Additional Information",
      submit: "Submit Partnership Request",
      submitting: "Submitting...",
      success: "Thank you! We'll contact you within 24 hours.",
      error: "Something went wrong. Please try again."
    },
    footer: {
      company: "Company",
      about: "About Us",
      capabilities: "Capabilities",
      technology: "Technology",
      contact: "Contact",
      support: "Support",
      faq: "FAQ",
      shipping: "Shipping Info",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      rights: "All rights reserved."
    }
  },
  tr: {
    nav: {
      capabilities: "Hizmetlerimiz",
      technology: "Teknoloji",
      pricing: "Fiyatlandırma",
      contact: "Ortaklık"
    },
    hero: {
      title: "Wall Art İşinizi Üretim Stresi Olmadan Büyütün",
      subtitle: "Premium kanvas duvar sanatını 5 iş günü içinde üretiyor ve optimize edilmiş tarifelerle ABD ve Kanada'ya gönderiyoruz—siz tasarım ve satışa odaklanın.",
      primaryCTA: "Ortaklık Talebi",
      secondaryCTA: "Yeteneklerimizi Görün"
    },
    whyUs: {
      title: "Ortaklar Neden Bizi Seçiyor",
      features: [
        {
          title: "Canon Colorado Baskı",
          description: "Keskin detay, tutarlı renk, üretim güvenilirliği"
        },
        {
          title: "Otomatik Germe",
          description: "Tutarlı, otomatik bitirme için Alman otomatik makineleri"
        },
        {
          title: "Özel Paketleme",
          description: "Daha iyi koruma için kendi üretimimiz tam ölçü kutular"
        },
        {
          title: "Hızlı Teslimat",
          description: "5 iş günü içinde üretim, ABD ve Kanada'ya optimize gönderim"
        }
      ]
    },
    printing: {
      title: "Canon Colorado UVGel Teknolojisi",
      description: "Gelişmiş UVGel 860 mürekkep teknolojisi, canlı ve bold renklerle olağanüstü çizilmeye dayanıklı baskılar sunar. Düşük sıcaklıkta kürleme işlemimiz boyutsal stabilite sağlarken, anında kuruma çıktısı mükemmel kanvas dokusunu korur. Yüksek mekanik dayanıklılık, kimyasal direnç ve tüm baskılarınızda üstün renk gamı deneyimleyin."
    },
    packaging: {
      title: "Her Siparişe Uygun Özel Kutular",
      description: "Kutu yapım sistemimiz, hasarı azaltmaya, alan tasarrufu sağlamaya ve teslimat güvenilirliğini artırmaya yardımcı olan tam ihtiyaç duyulan boyutu üretir."
    },
    frames: {
      title: "Gallery Wrapped ve Floating Frame Seçenekleri",
      description: "Walnut, Natural, Black ve White renk seçeneklerinde premium gallery wrapped kanvas ve floating frame seçenekleri sunun. Her çerçeve asma aparatı ile gelir ve asmaya hazırdır. Standart ve Extra Large boyutlarda mevcut olup her müşteri ihtiyacını karşılar."
    },
    shipping: {
      title: "Sigortalı FedEx Kargo ile ABD ve Kanada'ya Teslimat",
      description: "5 iş günü içinde üretim tamamlanır, ardından tam sigortalı FedEx ile gönderilir. Nakliyatta herhangi bir hasar mı oldu? Tam sorumluluk bizde ve hemen ücretsiz yenisini gönderiyoruz—soru sormadan."
    },
    pricing: {
      title: "En Uygun Ürün ve Kargo Fiyatlandırma",
      subtitle: "Esnek günlük ve haftalık ödeme seçenekleriyle rekabetçi fiyatlar",
      size: "Boyut",
      price: "Fiyat",
      currency: "USD",
      paymentOptions: "Günlük ve Haftalık Ödeme Seçenekleri Mevcut"
    },
    finalCTA: {
      title: "Üretim Yönetimini Bırakmaya Hazır Mısınız?",
      description: "Satış kanallarınızı ve günlük hacminizi paylaşın. Sonraki adımlarla size geri döneceğiz.",
      cta: "Ortaklık Talebi"
    },
    form: {
      title: "Ortaklık Talebi",
      name: "Ad Soyad",
      company: "Şirket Adı",
      email: "E-posta Adresi",
      phone: "Telefon Numarası",
      website: "Şirket Web Sitesi",
      salesChannels: "Satış Kanalları",
      salesChannelsPlaceholder: "örn., Etsy, Shopify, Amazon",
      orderVolume: "Günlük/Aylık Sipariş Hacmi",
      orderVolumePlaceholder: "örn., günde 50 sipariş",
      message: "Ek Bilgiler",
      submit: "Ortaklık Talebini Gönder",
      submitting: "Gönderiliyor...",
      success: "Teşekkürler! 24 saat içinde size ulaşacağız.",
      error: "Bir şeyler yanlış gitti. Lütfen tekrar deneyin."
    },
    footer: {
      company: "Şirket",
      about: "Hakkımızda",
      capabilities: "Yeteneklerimiz",
      technology: "Teknoloji",
      contact: "İletişim",
      support: "Destek",
      faq: "SSS",
      shipping: "Gönderim Bilgisi",
      terms: "Hizmet Şartları",
      privacy: "Gizlilik Politikası",
      rights: "Tüm hakları saklıdır."
    }
  },
  ru: {
    nav: {
      capabilities: "Наши Услуги",
      technology: "Технология",
      pricing: "Цены",
      contact: "Партнерство"
    },
    hero: {
      title: "Масштабируйте Свой Бизнес Настенного Искусства Без Стресса Производства",
      subtitle: "Мы производим премиальное настенное искусство на холсте за 5 рабочих дней и отправляем по США и Канаде с оптимизированными тарифами—чтобы вы могли сосредоточиться на дизайне и продажах.",
      primaryCTA: "Запрос Партнерства",
      secondaryCTA: "Наши Возможности"
    },
    whyUs: {
      title: "Почему Партнеры Выбирают Нас",
      features: [
        {
          title: "Печать Canon Colorado",
          description: "Четкие детали, стабильный цвет, надежность производства"
        },
        {
          title: "Автоматическая Натяжка",
          description: "Немецкие автоматические машины для стабильной отделки"
        },
        {
          title: "Индивидуальная Упаковка",
          description: "Коробки точного размера собственного производства для лучшей защиты"
        },
        {
          title: "Быстрое Выполнение",
          description: "Производство за 5 рабочих дней, оптимизированная доставка в США и Канаду"
        }
      ]
    },
    printing: {
      title: "Технология Canon Colorado UVGel",
      description: "Передовая технология чернил UVGel 860 обеспечивает исключительную устойчивость к царапинам с яркими, насыщенными цветами. Процесс отверждения при низкой температуре обеспечивает размерную стабильность, а мгновенная сушка сохраняет идеальную текстуру холста. Высокая механическая прочность, химическая стойкость и выдающаяся цветовая гамма во всех ваших отпечатках."
    },
    packaging: {
      title: "Индивидуальные Коробки Для Каждого Заказа",
      description: "Наша система производства коробок создает точный необходимый размер, помогая уменьшить повреждения, экономить место и повышать надежность доставки."
    },
    frames: {
      title: "Gallery Wrapped и Floating Frame Варианты",
      description: "Предлагайте премиальные gallery wrapped холсты и floating frame варианты в отделке Walnut, Natural, Black и White. Каждая рамка включает крепежное оборудование и готова к подвешиванию. Доступны в стандартных и Extra Large размерах для удовлетворения любых потребностей клиентов."
    },
    shipping: {
      title: "Застрахованная Доставка FedEx в США и Канаду",
      description: "Производство завершается в течение 5 рабочих дней, затем отправляется через FedEx с полной страховкой. Повреждение при транспортировке? Мы берем на себя полную ответственность и немедленно отправляем бесплатную замену—без вопросов."
    },
    pricing: {
      title: "Лучшие Цены на Продукты и Доставку",
      subtitle: "Конкурентные цены с гибкими ежедневными и еженедельными вариантами оплаты",
      size: "Размер",
      price: "Цена",
      currency: "USD",
      paymentOptions: "Доступны Ежедневные и Еженедельные Варианты Оплаты"
    },
    finalCTA: {
      title: "Готовы Прекратить Управление Производством?",
      description: "Поделитесь своими каналами продаж и ежедневным объемом. Мы ответим со следующими шагами.",
      cta: "Запрос Партнерства"
    },
    form: {
      title: "Запрос Партнерства",
      name: "Полное Имя",
      company: "Название Компании",
      email: "Электронная Почта",
      phone: "Номер Телефона",
      website: "Веб-сайт Компании",
      salesChannels: "Каналы Продаж",
      salesChannelsPlaceholder: "например, Etsy, Shopify, Amazon",
      orderVolume: "Ежедневный/Ежемесячный Объем Заказов",
      orderVolumePlaceholder: "например, 50 заказов/день",
      message: "Дополнительная Информация",
      submit: "Отправить Запрос Партнерства",
      submitting: "Отправка...",
      success: "Спасибо! Мы свяжемся с вами в течение 24 часов.",
      error: "Что-то пошло не так. Пожалуйста, попробуйте еще раз."
    },
    footer: {
      company: "Компания",
      about: "О Нас",
      capabilities: "Возможности",
      technology: "Технология",
      contact: "Контакты",
      support: "Поддержка",
      faq: "FAQ",
      shipping: "Информация о Доставке",
      terms: "Условия Обслуживания",
      privacy: "Политика Конфиденциальности",
      rights: "Все права защищены."
    }
  }
};

// Pricing data - 100 items as placeholder
export const pricingData = [
  { size: '36x24"', price: 36 },
  { size: '40x30"', price: 45 },
  { size: '48x32"', price: 55 },
  { size: '60x40"', price: 72 },
  { size: '72x48"', price: 95 },
  { size: '30x20"', price: 28 },
  { size: '32x24"', price: 32 },
  { size: '36x30"', price: 40 },
  { size: '42x28"', price: 48 },
  { size: '44x32"', price: 52 },
  { size: '50x40"', price: 68 },
  { size: '54x36"', price: 62 },
  { size: '60x48"', price: 82 },
  { size: '66x44"', price: 88 },
  { size: '70x50"', price: 98 },
  { size: '24x18"', price: 22 },
  { size: '28x20"', price: 26 },
  { size: '30x24"', price: 30 },
  { size: '34x26"', price: 36 },
  { size: '38x28"', price: 42 },
  { size: '40x32"', price: 46 },
  { size: '42x30"', price: 48 },
  { size: '44x30"', price: 50 },
  { size: '46x34"', price: 56 },
  { size: '48x36"', price: 58 },
  { size: '50x36"', price: 62 },
  { size: '52x38"', price: 66 },
  { size: '54x40"', price: 70 },
  { size: '56x42"', price: 74 },
  { size: '58x44"', price: 78 },
  { size: '60x42"', price: 80 },
  { size: '62x44"', price: 84 },
  { size: '64x46"', price: 88 },
  { size: '66x48"', price: 92 },
  { size: '68x50"', price: 96 },
  { size: '70x48"', price: 98 },
  { size: '72x50"', price: 102 },
  { size: '74x52"', price: 106 },
  { size: '76x54"', price: 110 },
  { size: '78x56"', price: 114 },
  { size: '80x58"', price: 118 },
  { size: '20x16"', price: 18 },
  { size: '22x18"', price: 20 },
  { size: '26x20"', price: 24 },
  { size: '28x22"', price: 28 },
  { size: '32x26"', price: 34 },
  { size: '34x28"', price: 38 },
  { size: '36x28"', price: 40 },
  { size: '38x30"', price: 44 },
  { size: '40x34"', price: 48 },
  { size: '42x32"', price: 50 },
  { size: '44x34"', price: 54 },
  { size: '46x36"', price: 58 },
  { size: '48x38"', price: 62 },
  { size: '50x38"', price: 64 },
  { size: '52x40"', price: 68 },
  { size: '54x42"', price: 72 },
  { size: '56x44"', price: 76 },
  { size: '58x46"', price: 80 },
  { size: '60x46"', price: 82 },
  { size: '62x48"', price: 86 },
  { size: '64x50"', price: 90 },
  { size: '66x50"', price: 94 },
  { size: '68x52"', price: 98 },
  { size: '70x52"', price: 100 },
  { size: '72x54"', price: 104 },
  { size: '74x56"', price: 108 },
  { size: '76x58"', price: 112 },
  { size: '78x60"', price: 116 },
  { size: '80x60"', price: 120 },
  { size: '18x12"', price: 15 },
  { size: '20x14"', price: 17 },
  { size: '22x16"', price: 19 },
  { size: '24x16"', price: 21 },
  { size: '26x18"', price: 23 },
  { size: '28x18"', price: 25 },
  { size: '30x22"', price: 29 },
  { size: '32x22"', price: 31 },
  { size: '34x24"', price: 35 },
  { size: '36x26"', price: 39 },
  { size: '38x26"', price: 41 },
  { size: '40x28"', price: 45 },
  { size: '42x34"', price: 51 },
  { size: '44x36"', price: 55 },
  { size: '46x38"', price: 59 },
  { size: '48x40"', price: 64 },
  { size: '50x42"', price: 68 },
  { size: '52x42"', price: 70 },
  { size: '54x44"', price: 74 },
  { size: '56x46"', price: 78 },
  { size: '58x48"', price: 82 },
  { size: '60x50"', price: 86 },
  { size: '62x50"', price: 88 },
  { size: '64x52"', price: 92 },
  { size: '66x54"', price: 96 },
  { size: '68x54"', price: 98 },
  { size: '70x56"', price: 102 },
  { size: '72x56"', price: 104 },
  { size: '74x58"', price: 108 },
  { size: '76x60"', price: 112 }
];

// Images
export const images = {
  printing: "https://images.unsplash.com/photo-1693031630369-bd429a57f115",
  printingAlt: "https://images.unsplash.com/photo-1503694978374-8a2fa686963a",
  packaging: "https://images.unsplash.com/photo-1764745021344-317b80f09e40",
  packagingAlt: "https://images.unsplash.com/photo-1758271452953-46f4e12ae2fd",
  frames: "https://images.unsplash.com/photo-1743119638006-a01d4625745d",
  framesAlt: "https://images.unsplash.com/photo-1696862048447-3ab8435ce5f1",
  shipping: "https://images.unsplash.com/photo-1740914994657-f1cdffdc418e",
  shippingAlt: "https://images.unsplash.com/photo-1766040923580-16ad32fae8b4"
};

// Slideshow Images - Wall Art Stretching & Canvas Production
export const slideshowImages = {
  en: [
    {
      url: "https://images.unsplash.com/photo-1770017863955-56a1501a3c93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxhcnQlMjBwcmludGluZyUyMHN0dWRpbyUyMGxhcmdlJTIwZm9ybWF0JTIwcHJpbnRlcnxlbnwwfHx8fDE3NzA0OTk0OTB8MA&ixlib=rb-4.1.0&q=85",
      title: "Large Format Art Printing",
      description: "Professional Canon printing technology for vibrant wall art production"
    },
    {
      url: "https://images.unsplash.com/photo-1696862048447-3ab8435ce5f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxhcnRpc3QlMjBzdHVkaW8lMjBjYW52YXMlMjBwYWludGluZ3MlMjB3b3Jrc3BhY2UlMjBjcmVhdGl2ZXxlbnwwfHx8fDE3NzA0OTk1NDd8MA&ixlib=rb-4.1.0&q=85",
      title: "Canvas Art Studio",
      description: "Creative workspace where wall art comes to life"
    },
    {
      url: "https://images.unsplash.com/photo-1705612206536-6578da92c06c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxjYW52YXMlMjBhcnQlMjB3YXJlaG91c2UlMjBzdG9yYWdlJTIwYXJ0d29ya3xlbnwwfHx8fDE3NzA0OTk1MDZ8MA&ixlib=rb-4.1.0&q=85",
      title: "Gallery Wrapped Canvas Storage",
      description: "Stretched canvas ready for packaging and shipping"
    },
    {
      url: "https://images.unsplash.com/photo-1638794224302-ed17a3ff0db9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxjYW52YXMlMjBhcnQlMjB3YXJlaG91c2UlMjBzdG9yYWdlJTIwYXJ0d29ya3xlbnwwfHx8fDE3NzA0OTk1MDZ8MA&ixlib=rb-4.1.0&q=85",
      title: "Art Production Workshop",
      description: "Skilled craftsmen creating premium wall art pieces"
    },
    {
      url: "https://images.unsplash.com/photo-1747197127318-76cf4098d770?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxmcmFtZWQlMjBjYW52YXMlMjBhcnQlMjBnYWxsZXJ5JTIwZGlzcGxheSUyMHdhbGx8ZW58MHx8fHwxNzcwNDk5NTAyfDA&ixlib=rb-4.1.0&q=85",
      title: "Framed Art Gallery",
      description: "Beautiful wall art collection showcasing our craftsmanship"
    },
    {
      url: "https://images.unsplash.com/photo-1724709162875-fe100dd0e04b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxhcnQlMjBwcm9kdWN0aW9uJTIwZmFjaWxpdHklMjBwYWNrYWdpbmclMjBzaGlwcGluZyUyMGJveGVzfGVufDB8fHx8MTc3MDQ5OTUzMHww&ixlib=rb-4.1.0&q=85",
      title: "Order Fulfillment Center",
      description: "Organized shipping and logistics for fast delivery"
    }
  ],
  tr: [
    {
      url: "https://images.unsplash.com/photo-1770017863955-56a1501a3c93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxhcnQlMjBwcmludGluZyUyMHN0dWRpbyUyMGxhcmdlJTIwZm9ybWF0JTIwcHJpbnRlcnxlbnwwfHx8fDE3NzA0OTk0OTB8MA&ixlib=rb-4.1.0&q=85",
      title: "Büyük Format Sanat Baskısı",
      description: "Canlı wall art üretimi için profesyonel Canon baskı teknolojisi"
    },
    {
      url: "https://images.unsplash.com/photo-1696862048447-3ab8435ce5f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxhcnRpc3QlMjBzdHVkaW8lMjBjYW52YXMlMjBwYWludGluZ3MlMjB3b3Jrc3BhY2UlMjBjcmVhdGl2ZXxlbnwwfHx8fDE3NzA0OTk1NDd8MA&ixlib=rb-4.1.0&q=85",
      title: "Kanvas Sanat Stüdyosu",
      description: "Wall art'ın hayat bulduğu yaratıcı çalışma alanı"
    },
    {
      url: "https://images.unsplash.com/photo-1705612206536-6578da92c06c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxjYW52YXMlMjBhcnQlMjB3YXJlaG91c2UlMjBzdG9yYWdlJTIwYXJ0d29ya3xlbnwwfHx8fDE3NzA0OTk1MDZ8MA&ixlib=rb-4.1.0&q=85",
      title: "Gallery Wrapped Kanvas Deposu",
      description: "Paketleme ve gönderime hazır gerilmiş kanvaslar"
    },
    {
      url: "https://images.unsplash.com/photo-1638794224302-ed17a3ff0db9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxjYW52YXMlMjBhcnQlMjB3YXJlaG91c2UlMjBzdG9yYWdlJTIwYXJ0d29ya3xlbnwwfHx8fDE3NzA0OTk1MDZ8MA&ixlib=rb-4.1.0&q=85",
      title: "Sanat Üretim Atölyesi",
      description: "Premium wall art eserleri üreten yetenekli ustalar"
    },
    {
      url: "https://images.unsplash.com/photo-1747197127318-76cf4098d770?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxmcmFtZWQlMjBjYW52YXMlMjBhcnQlMjBnYWxsZXJ5JTIwZGlzcGxheSUyMHdhbGx8ZW58MHx8fHwxNzcwNDk5NTAyfDA&ixlib=rb-4.1.0&q=85",
      title: "Çerçeveli Sanat Galerisi",
      description: "İşçiliğimizi sergileyen güzel wall art koleksiyonu"
    },
    {
      url: "https://images.unsplash.com/photo-1724709162875-fe100dd0e04b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxhcnQlMjBwcm9kdWN0aW9uJTIwZmFjaWxpdHklMjBwYWNrYWdpbmclMjBzaGlwcGluZyUyMGJveGVzfGVufDB8fHx8MTc3MDQ5OTUzMHww&ixlib=rb-4.1.0&q=85",
      title: "Sipariş Teslimat Merkezi",
      description: "Hızlı teslimat için organize kargo ve lojistik"
    }
  ],
  ru: [
    {
      url: "https://images.unsplash.com/photo-1770017863955-56a1501a3c93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxhcnQlMjBwcmludGluZyUyMHN0dWRpbyUyMGxhcmdlJTIwZm9ybWF0JTIwcHJpbnRlcnxlbnwwfHx8fDE3NzA0OTk0OTB8MA&ixlib=rb-4.1.0&q=85",
      title: "Широкоформатная Художественная Печать",
      description: "Профессиональная технология печати Canon для яркого настенного искусства"
    },
    {
      url: "https://images.unsplash.com/photo-1696862048447-3ab8435ce5f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxhcnRpc3QlMjBzdHVkaW8lMjBjYW52YXMlMjBwYWludGluZ3MlMjB3b3Jrc3BhY2UlMjBjcmVhdGl2ZXxlbnwwfHx8fDE3NzA0OTk1NDd8MA&ixlib=rb-4.1.0&q=85",
      title: "Студия Холстового Искусства",
      description: "Творческое пространство где рождается настенное искусство"
    },
    {
      url: "https://images.unsplash.com/photo-1705612206536-6578da92c06c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxjYW52YXMlMjBhcnQlMjB3YXJlaG91c2UlMjBzdG9yYWdlJTIwYXJ0d29ya3xlbnwwfHx8fDE3NzA0OTk1MDZ8MA&ixlib=rb-4.1.0&q=85",
      title: "Склад Gallery Wrapped Холстов",
      description: "Натянутые холсты готовые к упаковке и отправке"
    },
    {
      url: "https://images.unsplash.com/photo-1638794224302-ed17a3ff0db9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxjYW52YXMlMjBhcnQlMjB3YXJlaG91c2UlMjBzdG9yYWdlJTIwYXJ0d29ya3xlbnwwfHx8fDE3NzA0OTk1MDZ8MA&ixlib=rb-4.1.0&q=85",
      title: "Мастерская Художественного Производства",
      description: "Квалифицированные мастера создают премиальные произведения"
    },
    {
      url: "https://images.unsplash.com/photo-1747197127318-76cf4098d770?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxmcmFtZWQlMjBjYW52YXMlMjBhcnQlMjBnYWxsZXJ5JTIwZGlzcGxheSUyMHdhbGx8ZW58MHx8fHwxNzcwNDk5NTAyfDA&ixlib=rb-4.1.0&q=85",
      title: "Галерея Обрамленного Искусства",
      description: "Коллекция настенного искусства демонстрирующая наше мастерство"
    },
    {
      url: "https://images.unsplash.com/photo-1724709162875-fe100dd0e04b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxhcnQlMjBwcm9kdWN0aW9uJTIwZmFjaWxpdHklMjBwYWNrYWdpbmclMjBzaGlwcGluZyUyMGJveGVzfGVufDB8fHx8MTc3MDQ5OTUzMHww&ixlib=rb-4.1.0&q=85",
      title: "Центр Выполнения Заказов",
      description: "Организованная доставка и логистика для быстрой отправки"
    }
  ]
};

// Mock form submission
export const submitPartnershipForm = async (formData) => {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Store in localStorage for demo
  const submissions = JSON.parse(localStorage.getItem('partnershipSubmissions') || '[]');
  submissions.push({
    ...formData,
    timestamp: new Date().toISOString()
  });
  localStorage.setItem('partnershipSubmissions', JSON.stringify(submissions));
  
  return { success: true };
};
